import Configuration from '../models/configuration';
import namespace from '../../upi/namespace';

var app = namespace( 'apps.productpage' );

var ConfigurationList = Backbone.Collection.extend( {

    model: Configuration,

    _current: null,

    initialize: function ( models, options ) {
        // add event bindings and mediator
        this.listenTo( this, 'select:one', this.current );
        this.listenTo( this, 'select:one', app.mediator.willTrigger( 'next:target' ) );
        this.listenTo( app.mediator, 'set:configuration', this.setConfiguration );

        this.unsetCurrent();
    },

    /**
     * return a list of configuration on the same level as the provided configuration item
     * @param ConfigurationModel
     * @returns Array[ConfigurationModel]
     */
    getSiblingCollection: function ( item ) {
        return this.filter( function ( model ) {
            return model.get( 'parentGroupId' ) === item.get( 'parentGroupId' );
        }, this );
    },

    /**
     * return a list of configurations that are children of the provided configuration
     * @param ConfigurationModel
     * @returns Array[ConfigurationModel]
     */
    getChildCollection: function ( item ) {
        return this.filter( function ( model ) {
            var groups = item.get( 'groups' );
            return groups.length && groups.indexOf( model.get( 'groupId' ) ) !== -1;
        }, this );
    },

    clearSelected: function ( current ) {
        this.each( function ( model ) {
            // determine if model is a prent of current, if so ensure it stays in a selected state
            var parentGroupId = current.get( 'parentGroupId' ),
                isParent = (parentGroupId !== null && model.get( 'groupId' ) === parentGroupId);

            model.set( 'selected', isParent );
        } );
        this.unsetCurrent();
    },

    /**
     * Only allow a single option in collection to be selected at one time, resetting all items in collection
     * @param option
     * @returns {*}
     */
    current: function ( configuration ) {
        // getter/setter
        if ( configuration ) {
            this.clearSelected( configuration );
            configuration.set( {selected: true} );
            return this._current = configuration;
        }

        return this._current;
    },

    /**
     * Set the set the configurator to the provided configurationId and option skuId
     * @param {number} configurationId
     * @param {number} skuId (optional)
     */
    setConfiguration: function ( configurationId, skuId ) {
        var configuration = this.findWhere( {groupId: configurationId} );

        if ( configuration ) {
            configuration.select();
            // if there is a sku, set it's options in configurator
            if ( skuId ) {
                var sku = configuration.skuList.find( {id: skuId} );
                // not all configurations will have an optionGroupList
                configuration.optionGroupList && configuration.optionGroupList.setSelected( sku.get( 'options' ) );
            }
        }
    },

    unsetCurrent: function () {
        this._current = null;
    }

} );

export default ConfigurationList;
